import React from 'react';

const WorkOrderStep7Execution = ({ formData, setFormData, formErrors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Execution Section</h3>
        <div className="row">
          <div className="form-group col-md-3">
            <label htmlFor="actualStartDate">Actual Start Date</label>
            <input
              type="date"
              id="actualStartDate"
              name="actualStartDate"
              value={formData.actualStartDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="actualStartTime">Actual Start Time</label>
            <input
              type="datetime-local"
              id="actualStartTime"
              name="actualStartTime"
              value={formData.actualStartTime}
              onChange={handleChange}
            />
          </div>

          <div className="form-group col-md-3">
            <label htmlFor="actualEndDate">Actual End Date</label>
            <input
              type="date"
              id="actualEndDate"
              name="actualEndDate"
              value={formData.actualEndDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="actualEndTime">Actual End Time</label>
            <input
              type="datetime-local"
              id="actualEndTime"
              name="actualEndTime"
              value={formData.actualEndTime}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="actualDurationHours">Actual Duration (hours)</label>
            <input
              type="number"
              id="actualDurationHours"
              name="actualDurationHours"
              value={formData.actualDurationHours}
              onChange={handleChange}
              step="0.1"
              min="0"
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="downtimeMinutes">Downtime (minutes)</label>
            <input
              type="number"
              id="downtimeMinutes"
              name="downtimeMinutes"
              value={formData.downtimeMinutes}
              onChange={handleChange}
              min="0"
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="technicianNotes">Technician Notes - Work Performed Summary</label>
            <textarea
              id="technicianNotes"
              name="technicianNotes"
              value={formData.technicianNotes}
              onChange={handleChange}
              placeholder="Describe the work performed..."
              rows="3"
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="observations">Observations</label>
            <textarea
              id="observations"
              name="observations"
              value={formData.observations}
              onChange={handleChange}
              placeholder="Enter any observations during the work..."
              rows="3"
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="additionalIssues">Additional Issues Found</label>
            <textarea
              id="additionalIssues"
              name="additionalIssues"
              value={formData.additionalIssues}
              onChange={handleChange}
              placeholder="Note any additional issues discovered..."
              rows="3"
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="readingsJson">Readings (JSON - Temperature, Pressure, Vibration, Oil Level, etc.)</label>
            <textarea
              id="readingsJson"
              name="readingsJson"
              value={formData.readingsJson}
              onChange={handleChange}
              placeholder='JSON: {"temperature": 25, "pressure": 100, "vibration": 0.5}'
              rows="3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep7Execution;

